import Vue from "vue";
import Router from "vue-router";

import store from "../store";

import Main from "../view/Main";
import ForgotPassword from "../view/login/ForgotPassword";
import Login from "../view/login/Login";
import {
  getLoginAction
} from "../components/MessageBus";

const UserList = () => import("../view/crud/UserList.vue");

const UserInput = () => import("../view/crud/UserInput.vue");

const CompanyList = () => import("../view/crud/CompanyList");

const CompanyInput = () => import("../view/crud/CompanyInput");

const CompanyMain = () => import("../view/crud/CompanyMain");

const CompanyPaymentResume = () => import("../view/crud/CompanyPaymentResume");

const CompanyAccessLog = () => import("../view/crud/CompanyAccessLog");

const CompanyPlan = () => import("../view/crud/CompanyPlan");

const ProfileList = () => import("../view/crud/ProfileList");

const ProfileInput = () => import("../view/crud/ProfileInput");

const PlanList = () => import("../view/crud/PlanList");

const PlanInput = () => import("../view/crud/PlanInput");

const PaymentList = () => import("../view/crud/PaymentList");

const PaymentInput = () => import("../view/crud/PaymentInput");

const LogList = () => import("../view/crud/LogList");

const LogInput = () => import("../view/crud/LogInput");

const VideoChangeLogList = () => import("../view/crud/VideoChangeLogList");

const VideoChangeLogInput = () => import("../view/crud/VideoChangeLogInput");

const ServerList = () => import("../view/crud/ServerList");

const ServerInput = () => import("../view/crud/ServerInput");

const UserMapsList = () => import("../view/smartmaps/UserMapsList");

const UserMapsInput = () => import("../view/smartmaps/UserMapsInput");

const ProfileMapsList = () => import("../view/smartmaps/ProfileMapsList");

const ProfileMapsInput = () => import("../view/smartmaps/ProfileMapsInput");

const ConfigMapsInput = () => import("../view/smartmaps/ConfigMapsInput");

const ExtractKmlMapsList = () => import("../view/smartmaps/ExtractKmlMapsList");

const ExtractKmlMapsInput = () =>
  import("../view/smartmaps/ExtractKmlMapsInput");

const DeleteFolderMapsInput = () =>
  import("../view/smartmaps/DeleteFolderMapsInput");

const EmailList = () => import("../view/crud/EmailList");

const ErpList = () => import("../view/crud/ErpList");

const ErpInput = () => import("../view/crud/ErpInput");

const GroupPageList = () => import("../view/crud/GroupPageList");

const GroupPageInput = () => import("../view/crud/GroupPageInput");

const PageList = () => import("../view/crud/PageList");

const PageInput = () => import("../view/crud/PageInput");

const MessageList = () => import("../view/crud/MessageList");

const MessageInput = () => import("../view/crud/MessageInput");

const NotificationList = () => import("../view/notification/NotificationList");

import { HTTP, setTokenHeader } from "../request/request";

import localStore from "../components/extra/LocalStorage";

import { autoLoginPath } from "../router/ApiPaths";
import { hasPermission } from "../components/permission/hasPermission";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "Main",
      component: Main
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/forgotpassword",
      name: "forgotpassword",
      component: ForgotPassword
    },
    {
      path: "/company",
      name: "companylist",
      component: CompanyList,
      meta: {
        permission: ["EMP", "VI"]
      }
    },
    {
      path: "/companyplan/:id",
      name: "companyplan",
      component: CompanyPlan,
      meta: {
        permission: ["EMP", "VI"]
      }
    },
    {
      path: "/company/:id",
      component: CompanyMain,
      children: [
        {
          path: "",
          name: "companyinput",
          component: CompanyInput
        },
        {
          path: "/paymentresume/:id",
          name: "companyPaymentResume",
          component: CompanyPaymentResume
        },
        {
          path: "/usermaps",
          name: "userMapsList",
          component: UserMapsList,
          meta: {
            permission: ["CAD", "VI"]
          }
        },
        {
          path: "/usermaps/:id",
          name: "userMapsInput",
          component: UserMapsInput,
          meta: {
            permission: ["CAD", "VI"]
          }
        },
        {
          path: "/profilemaps",
          name: "profileMapsList",
          component: ProfileMapsList,
          meta: {
            permission: ["CAD", "VI"]
          }
        },
        {
          path: "/profilemaps/:id",
          name: "profileMapsInput",
          component: ProfileMapsInput,
          meta: {
            permission: ["CAD", "VI"]
          }
        },
        {
          path: "/extractkml",
          name: "extractKmlMapsList",
          component: ExtractKmlMapsList,
          meta: {
            permission: ["CAD", "VI"]
          }
        },
        {
          path: "/extractkml/:id",
          name: "extractKmlMapsInput",
          component: ExtractKmlMapsInput,
          meta: {
            permission: ["CAD", "VI"]
          }
        },
        {
          path: "/deletefolder",
          name: "deleteFolderMapsInput",
          component: DeleteFolderMapsInput,
          meta: {
            permission: ["CAD", "VI"]
          }
        },
        {
          path: "/configmaps",
          name: "configMapsList",
          component: ConfigMapsInput,
          meta: {
            permission: ["CAD", "VI"]
          }
        },
        {
          path: "/companyaccesslog",
          name: "companyAccessLog",
          component: CompanyAccessLog,
          meta: {
            permission: ["CAD", "VI"]
          }
        }
      ],
      meta: {
        permission: ["EMP", "CA", "AT"]
      }
    },
    {
      path: "/user",
      name: "userlist",
      component: UserList,
      meta: {
        permission: ["USU", "VI"]
      }
    },
    {
      path: "/user/:id",
      name: "userinput",
      component: UserInput,
      meta: {
        permission: ["USU", "CA", "AT"]
      }
    },
    {
      path: "/profile",
      name: "profilelist",
      component: ProfileList,
      meta: {
        permission: ["PRO", "VI"]
      }
    },
    {
      path: "/profile/:id",
      name: "profileinput",
      component: ProfileInput,
      meta: {
        permission: ["PRO", "CA", "AT"]
      }
    },
    {
      path: "/plan",
      name: "planlist",
      component: PlanList,
      meta: {
        permission: ["PLA", "VI"]
      }
    },
    {
      path: "/plan/:id",
      name: "planinput",
      component: PlanInput,
      meta: {
        permission: ["PLA", "CA", "AT"]
      }
    },
    {
      path: "/payment",
      name: "paymentList",
      component: PaymentList,
      meta: {
        permission: ["PAG", "VI"]
      }
    },
    {
      path: "/payment/:id",
      name: "paymentInput",
      component: PaymentInput,
      meta: {
        permission: ["PAG", "CA"]
      }
    },
    {
      path: "/log/:logId/videochangelog",
      name: "videoChangeLogList",
      component: VideoChangeLogList,
      meta: {
        permission: ["VCH", "VI"]
      }
    },
    {
      path: "/log/:logId/videochangelog/:id",
      name: "videoChangeLogInput",
      component: VideoChangeLogInput,
      meta: {
        permission: ["VCH", "CA", "AT"]
      }
    },
    {
      path: "/log",
      name: "loglist",
      component: LogList,
      meta: {
        permission: ["CHL", "VI"]
      }
    },
    {
      path: "/log/:id",
      name: "loginput",
      component: LogInput,
      meta: {
        permission: ["CHL", "CA", "AT"]
      }
    },
    {
      path: "/server",
      name: "serverlist",
      component: ServerList,
      meta: {
        permission: ["EMP", "VI"]
      }
    },
    {
      path: "/server/:id",
      name: "serverinput",
      component: ServerInput,
      meta: {
        permission: ["EMP", "CA", "AT"]
      }
    },
    {
      path: "/email",
      name: "emailList",
      component: EmailList
      // meta: {
      // permission: ["USU", "VI"]
      // }
    },
    {
      path: "/erp",
      name: "erplist",
      component: ErpList,
      meta: {
        permission: ["ERP", "VI"]
      }
    },
    {
      path: "/erp/:id",
      name: "erpinput",
      component: ErpInput,
      meta: {
        permission: ["ERP", "CA", "AT"]
      }
    },
    {
      path: "/grouppage",
      name: "groupPagelist",
      component: GroupPageList,
      meta: {
        permission: ["GRP", "VI"]
      }
    },
    {
      path: "/grouppage/:id",
      name: "grouppageinput",
      component: GroupPageInput,
      meta: {
        permission: ["GRP", "CA", "AT"]
      }
    },
    {
      path: "/grouppage/:groupPageId/page",
      name: "pagelist",
      component: PageList,
      meta: {
        permission: ["PAI", "VI"]
      }
    },
    {
      path: "/grouppage/:groupPageId/page/:id",
      name: "pageinput",
      component: PageInput,
      meta: {
        permission: ["PAI", "CA", "AT"]
      }
    },
    {
      path: "/message",
      name: "messageList",
      component: MessageList,
      meta: {
        permission: ["MSG", "VI"]
      }
    },
    {
      path: "/message/:id",
      name: "messageInput",
      component: MessageInput,
      meta: {
        permission: ["MSG", "CA", "AT"]
      }
    },
    {
      path: "/notification",
      name: "notificationList",
      component: NotificationList,
      meta: {
        // permission: ["MSG", "VI"]
      }
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});

const validateToken = token => {
  setTokenHeader(token);
  return HTTP.get(autoLoginPath);
};

router.beforeEach(function(to, from, next) {
  store.dispatch("startLoading");
  // console.log(hasPermission(to.meta.permission), to.meta.permission);
  if (to.meta.permission && !hasPermission(to.meta.permission)) {
    next("/");
    store.dispatch("endLoading");
  } else {
    if (
      !store.getters.isLogged &&
      (to.name === "login" || to.name === "forgotpassword")
    ) {
      next();
      store.dispatch("endLoading");
    } else if (!store.getters.isLogged) {
      store.dispatch("startLoading");
      const localToken = localStore.get();
      if (localToken) {
        validateToken(localToken)
          .then(response => {
            store.dispatch("setLogin", {
              user: response.data,
              token: localToken
            });
            next("/");
            store.dispatch("endLoading");
          })
          .catch(error => {
            console.log("error " + error);
            next("/login");
          });
      } else {
        next("/login");
      }
    } else {
      next();
    }
  }
});

router.beforeResolve((to, from, next) => {
  store.dispatch("endLoading");
  next();
});

getLoginAction(()=>{
  router.go("/login")
})

export default router;



// WEBPACK FOOTER //
// /src/router/index.js